import { STATES_AND_PROVINCES } from "./constants";

export const isValidPhone = (phone: string) => {
  // Remove all non-digit characters
  const digitsOnly = phone.replace(/\D/g, "");

  // Check if there are exactly 10 digits
  if (digitsOnly.length !== 10) {
    return false;
  }

  // Check if the area code doesn't begin with 1
  if (digitsOnly[0] === "1") {
    return false;
  }

  return true;
};

export const isValidEmail = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const isValidStateOrStateCode = (value: string) => {
  if (value.length <= 3) {
    return STATES_AND_PROVINCES.some(
      (state) => state.stateCode === value.toUpperCase(),
    );
  }
  return STATES_AND_PROVINCES.some(
    (state) => state.label.toUpperCase() === value.toUpperCase(),
  );
};

export function isValidURL(value: string | undefined): boolean {
  if (!value) return false;
  return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    value,
  );
}
